import { render, staticRenderFns } from "./ddo-file-manager-view.vue?vue&type=template&id=1f840cf9&scoped=true"
import script from "./ddo-file-manager-view.vue?vue&type=script&lang=js"
export * from "./ddo-file-manager-view.vue?vue&type=script&lang=js"
import style0 from "./ddo-file-manager-view.vue?vue&type=style&index=0&id=1f840cf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f840cf9",
  null
  
)

export default component.exports